import { apiClient } from './api';
import { db } from './firebase';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';

export interface User {
  uid: string;
  email: string;
  fullName?: string;
  phone?: string;
  role: 'user' | 'admin' | 'restaurant' | 'restaurant_admin' | 'courier';
  status: 'active' | 'inactive' | 'suspended';
  createdAt: { seconds: number; nanoseconds: number };
}

/**
 * Listar usuarios (Directo a Firestore)
 */
export const listUsers = async () => {
  try {
    const q = query(collection(db, 'users'), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    const users = snapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() } as User));
    return users;
  } catch (error) {
    console.error("Error listing users:", error);
    return [];
  }
};

export const setUserRole = async (uid: string, role: string) => {
  const response = await apiClient.post('/setUserRole', { uid, role });
  return response.data;
};

export const usersService = {
  listUsers,
  setRole: setUserRole
};
